<div class="dropControl_wrapper">
    <div class="sample_wrapper text-center">
        <div class="dropArea_wrap col-sm-12" id="dropTarget">
            <div class="font-icons">
                <i class="fas {{iconClassName}}"></i>
            </div>
            <h3 class="dropText"  tabindex="0" aria-label="Drag and drop a file here" role="heading" aria-level="3">
                Drag and drop {{multipleFileMode ? 'files' : 'a file'}} here to upload data<br /><small>{{formatDisplayText}}</small>
            </h3>
            <div id="droppingArea" class="dropping-area" [style.max-height]="maxDropAreaHeight ? maxDropAreaHeight + 'px' : 'auto'">
                <ejs-uploader #defaultupload
                    id="fileupload"
                    class="dropFiles"
                    [multiple]="multipleFileMode"
                    [autoUpload]="autoUploadEnabled"
                    [dropArea]="dropElement"
                    [allowedExtensions]="allowExtensions"
                    [asyncSettings]="uploadSettings"
                    [minFileSize]="fileMinSize"
                    [maxFileSize]="fileMaxSize"
                    [sequentialUpload]="sequentialUpload"
                    (selected)="onFileSelected($event)"
                    (uploading)="onUploading($event)"
                    (success)="onSuccess($event)"
                    (failure)="onFailure($event)"
                    (failure)="onfailure($event)">
                </ejs-uploader>
            </div>
        </div>
        <div class="top-space e-text-center">
            <span id="drop">
                <a class="btn btn-primary form-filters-action-button top-space" id="browse" (click)='browseClick()' tabindex="0" role="link" aria-label="select file from your desktop" (keydown.enter)="browseClick()">
                    Or select from your desktop
                </a>
            </span>
        </div>
    </div>
</div>
